import React from "react";

import { NoResultsContainer } from "@faire/retailer/components/NoResults";
import { useClearCategoryPageFilters } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/NoResults/__internal__/useClearCategoryPageFilters";
import { useIsCategoryPageFiltered } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/NoResults/__internal__/useIsCategoryPageFiltered";

export const CategoryPageNoResults = ({
  showProductFirstResults,
  categoryPageLoadTimingRef,
}: {
  showProductFirstResults?: boolean;
  categoryPageLoadTimingRef: React.Ref<HTMLDivElement> | undefined;
}) => {
  const isFiltered = useIsCategoryPageFiltered();
  const handleClearFilters = useClearCategoryPageFilters();

  return (
    <NoResultsContainer
      showProductFirstResults={showProductFirstResults}
      hasFiltersApplied={isFiltered}
      onClearFilters={handleClearFilters}
      divRef={categoryPageLoadTimingRef}
    />
  );
};
